<template>
  <iframe name="rectifyStatusDetailIframe" v-if="rectifyStatusDetailIframeFlag"></iframe>
  <div class="" v-if="!rectifyStatusDetailIframeFlag">
    <h-list-page style="height: 810px;">
      <h-card :title="h_i18n('13fe8d8c74cb94357d8e105686778dfe')" width="100%" footer is-search @change-method="changeMethod">
        <h-area title-width="90px" :all-span="7" v-if="dataFrom == 'sqm'">
          <template #subheading>
            <el-radio-group v-model="monthType" size="small">
              <el-radio-button :label="h_i18n('f2cf263977bb4fd33b4fed19abfa61ce')" value="1" />
              <el-radio-button :label="h_i18n('8b2c70fbed996fe6bb9b7e75f5253d47')" value="2" />
            </el-radio-group>
          </template>
          <h-search :title="h_i18n('4ced958130fb30fb78b7c48112a37e20')">
            <h-date-picker v-model="time" @change="chosetime" type="month" :placeholder="h_i18n('e42b99d59954ce6437e66f416850425a')"> </h-date-picker>
          </h-search>
          <h-search :title="h_i18n('f3737dbfae61193590bd513df85ff250')">
            <h-input :placeholder="h_i18n('f3737dbfae61193590bd513df85ff250')" v-model="searchData.ppmCode"></h-input>
          </h-search>

          <h-search :title="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')">
            <h-input :placeholder="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" v-model="searchData.mtlNo"></h-input>
          </h-search>
          <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
            <h-input :placeholder="h_i18n('03490f3868798323211aa633194df2c1')" v-model="searchData.sybName"></h-input>
          </h-search>
          <h-search :title="h_i18n('79101b9a4632dcc59011cbfd47f4bbcc')">
            <h-input :placeholder="h_i18n('79101b9a4632dcc59011cbfd47f4bbcc')" v-model="searchData.plName"></h-input>
          </h-search>
          <h-search :title="h_i18n('0fa9d1590c4e12905a78e001e7332c5d')">
            <h-select :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" v-model="searchData.rectifyStatus" clearable @change="changeSectifyStatus">
              <h-option key="1222 " :label="h_i18n('e17445c380a7667d92f87d01d6703e42')" value="1222"></h-option>
              <h-option key="2159" :label="h_i18n('ef5db409ff725e8482b6eb65f38c48af')" value="2159"></h-option>
              <h-option key="2160" :label="h_i18n('faed4c5f6d0759abc15ec2971cad306d')" value="2160"></h-option>
              <h-option key="2161" :label="h_i18n('9d298bcaba9221bf30fd13a4b06e2683')" value="2161"></h-option>
              <h-option key="2162" :label="h_i18n('cc939a5a94d19ffb864a8f14200237fe')" value="2162"></h-option>
              <h-option key="2163" :label="h_i18n('f950331889d2172fbdeb4ddfbd135510')" value="2163"></h-option>
            </h-select>
          </h-search>
          <h-search :title="h_i18n('72d70086afce3d043fc51e0523192bd2')">
            <h-select :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" v-model="searchData.tripOut" clearable @change="changeSectifyStatus">
              <h-option :key="h_i18n('88b3219b36f6266a0f167ce9b29a9896')" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')" value="是"></h-option>
              <h-option :key="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" value="否"></h-option>
            </h-select>
          </h-search>
          <h-search :title="h_i18n('8df14303f8eb277b1ade948458e7c876')">
            <h-select :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" v-model="searchData.twoMonths" clearable @change="changeSectifyStatus">
              <h-option :key="h_i18n('88b3219b36f6266a0f167ce9b29a9896')" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')" value="是"></h-option>
              <h-option :key="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" value="否"></h-option>
            </h-select>
          </h-search>
          <h-search :title="h_i18n('aa1a29a3ee85b84086ff2f930288226d')">
            <h-select :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" v-model="searchData.threeMonths" clearable @change="changeSectifyStatus">
              <h-option :key="h_i18n('88b3219b36f6266a0f167ce9b29a9896')" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')" value="是"></h-option>
              <h-option :key="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" value="否"></h-option>
            </h-select>
          </h-search>
          <h-search :title="h_i18n('e39e50979b1597d51fbca7db64dab8b6')">
            <h-select :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" v-model="searchData.twelfthMonths" clearable @change="changeSectifyStatus">
              <h-option v-for="(i, v) in 13" :label="v" :value="v" :key="i"></h-option>
            </h-select>
          </h-search>
          <template #operate>
            <h-button type="primary" :loading="loading" @click="handleCurrentChange(1)">
              <template #icon>
                <search />
              </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
          </template>
          <template #reset>
            <h-button type="default" :loading="tableListLoading">
              <template #icon>
                <refresh />
              </template>{{ h_i18n('4b9c3271dc2f299dc3aeffb369187513') }}</h-button>
          </template>
        </h-area>

      </h-card>

      <h-card :title="h_i18n('daff820eece267de918a5896cbaaa389')">
        <template #subheading>
          <el-radio-group v-model="monthType" size="small" @change="groupType">
            <el-radio-button :label="h_i18n('f2cf263977bb4fd33b4fed19abfa61ce')" value="1" />
            <el-radio-button :label="h_i18n('8b2c70fbed996fe6bb9b7e75f5253d47')" value="2" />
          </el-radio-group>
        </template>
        <template #buttonGroup>
          <h-button-group>
            <h-button
              type="primary"
              @click="EXport()"
              newEx="true"
              v-if="chargeButList.length > 0 && chargeButList[0].code == 'S01053_XC_PPM_CDX_DC'"
            >
              <i class="iconfont icon-daochu"></i>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
          </h-button-group>
        </template>
        <el-table
          @current-change="clickrow"
          highlight-current-row
          v-loading="loading"
          :data="tableData"
          border
          size="small"
          height="540"
          style="width: 100%; min-height: 540px"
        >
          <el-table-column prop="yearmonth" :label="h_i18n('4ced958130fb30fb78b7c48112a37e20')" width="100" align="left"></el-table-column>
          <el-table-column prop="ppmCode" :label="h_i18n('f3737dbfae61193590bd513df85ff250')" width="160" align="left"></el-table-column>
          <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120" align="left"></el-table-column>
          <el-table-column align="left" prop="mtlName" width="191px" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
            <template #default="scope">
              <div style="text-align: left; width: 160px; overflow: hidden; text-overflow: ellipsis">{{ scope.row.mtlName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="mtlGroup" :label="h_i18n('9aa8f711298fef621b1c74335c2a8670')" width="80" align="left"></el-table-column>
          <el-table-column prop="materielCategoryName" :label="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')" width="80" align="left"></el-table-column>
          <el-table-column prop="supplyCode" :label="h_i18n('5a4004d280ff74beb329402f267477e6')" width="100" align="left"></el-table-column>
          <el-table-column align="left" prop="supplyName" width="181px" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')">
            <template #default="scope">
              <div style="text-align: left; width: 160px; overflow: hidden; text-overflow: ellipsis">{{ scope.row.supplyName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="plName" :label="h_i18n('79101b9a4632dcc59011cbfd47f4bbcc')" width="90" align="left"></el-table-column>
          <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" width="90" align="left"></el-table-column>
          <template v-for="(item, index) in tableHead" :key="index">
            <!-- 批量表头里，个性化设置 纠偏单号 rectifyId的a链接 -->
            <el-table-column v-if="item.property === 'rectifyId'" :label="item.label" :width="item.width" :property="item.property" align="center">
              <template #default="scope">
                  <span class="spanLikeA" @click="openNewPageOfRectifyDetail(scope.row.rectifyId)">{{ scope.row.rectifyId }}</span>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.property === 'rectifyDate'" :label="item.label" :width="item.width" :property="item.property" align="center">
              <template #default="scope">
                {{ time1(scope.row.rectifyDate) }}
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.property === 'stopDate'" :label="item.label" :width="item.width" :property="item.property" align="center">
              <template #default="scope">
                {{ time1(scope.row.stopDate) }}
              </template>
            </el-table-column>
            <el-table-column v-else :label="item.label" :width="item.width" :property="item.property" align="center"></el-table-column>
          </template>
          <el-table-column prop="insertTime" :label="h_i18n('a001a226fdc34fd7121f9c4839c759a2')" min-width="170" :formatter="dealDate"></el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-model:pageNo="pagenation.pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, prev, pager, next,jumper"
          :total="total"
        >
        </el-pagination>
      </h-card>
    </h-list-page>
  </div>
</template>
<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from 'moment';

export default {
  name: 'HMQMlist',
  data() {
    return {
      rectifyStatusDetailIframeFlag: false,
      dialogVisible: false,
      value: '',
      pagenation: {
        pageNo: 1
      },
      time: new Date(),
      year: '',
      mouth: '',
      dataFrom: '',
      total: 0,
      tableHead: [],
      tableData2: [],
      tableData: [],
      searchData: {
        supplyCode: '',
        lockFlag: 0
      },
      currentRow: '',
      loading: false,
      roleCode: '',
      chargeButList: [],
      NODE_ENV: null,
      supplierList: [],
      isShowsupplierList: false,
      mtlNoloading: false,
      blur: false,
      monthType: h_i18n('8b2c70fbed996fe6bb9b7e75f5253d47')
    };
  },
  methods: {
    h_i18n,
    time1(dataStr, len = 3) {
      if (!dataStr) {
        return '';
      }
      let date = new Date(dataStr);
      let y = date.getFullYear();

      let m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;

      let d = date.getDate();
      d = d < 10 ? '0' + d : d;

      let h = date.getHours();
      h = h < 10 ? '0' + h : h;

      //获得分
      let mm = date.getMinutes();
      mm = mm < 10 ? '0' + mm : mm;

      //获得秒
      let ss = date.getSeconds();
      ss = ss < 10 ? '0' + ss : ss;
      // console.log(y+'-'+m+'-'+d+' '+h+':'+mm+':'+ss)
      if (len === 3) {
        return y + '-' + m + '-' + d;
      } else if (len === 6) {
        return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + ss;
      } else if (len === 1) {
        return y;
      } else if (len === 2) {
        return m;
      } else {
        return h_i18n('86c278b0635e68da4c9a2a7049f1c593');
      }
    },
    groupType(a) {
      if (a === h_i18n('f2cf263977bb4fd33b4fed19abfa61ce')) {
        this.searchData.lockFlag = 1;
      } else if (a === h_i18n('8b2c70fbed996fe6bb9b7e75f5253d47')) {
        let month = new Date().getMonth() + 1;
        if (this.month === month) {
          this.searchData.lockFlag = 0;
        } else {
          this.searchData.lockFlag = 2;
        }
      }
      this.getReportLVist();
    },
    changeMethod() {
      this.postThisPageHeight();
      // this.setEveryTableWight(7)
    },
    myBlur(v) {
      if (!this.blur) {
        this[v] = false;
      }
    },
    myFocus4(v) {
      this.blur = false;
      // console.log(this.searchData.supplyCode.length)
      if (this.searchData.supplyCode.length >= 2) {
        this[v] = true;
      }
    },

    clicksupplyCode(row) {
      console.log(row);
      this.blur = true;
      this.searchData.supplyCode = row.supplyCode;
      this.isShowsupplierList = false;
      // this.searchData.supplyCode = val;
      // this.isShowsupplierList = false;
      // this.$nextTick(() => {
      //   this.$refs.supplyCode.focus();
      // });
    },
    clearsupplyCode() {
      this.isShowsupplierList = false;
    },
    // 选择纠偏单状态
    changeSectifyStatus(e) {
      //console.log(this.searchData.rectifyStatus)
    },
    // 跳转纠偏单详情页面
    openNewPageOfRectifyDetail(rectifyId) {
      // if(this.NODE_ENV == "production"){
      //   window.open("https://hmqm.haier.net/rejects/rectify_detail?rectifyId="+rectifyId)
      // }else{
      // top.postMessage(rectifyId, '*');
      //window.open("http://10.138.16.184:8998/rejects/rectify_detail?rectifyId="+rectifyId)
      // }
    },
    getNewproductList() {
      this.$http({
        method: 'get',
        url: '/base/hpc/searchButton',
        params: {
          url: '/financialStatementAnalysis/scenePPM/view'
        }
      }).then((res) => {
        this.loading = false;
        if (res.status == 200 && res.data.code == 1) {
          if (res.data.data) {
            this.chargeButList = res.data.data.hacResourceDtoList || [];
          }
        }
      });
    },
    getChargeButList(name) {
      for (let i = 0; i < this.chargeButList.length; i++) {
        if (name == this.chargeButList[i].name) {
          return true;
        }
      }
      return false;
    },
    goReport(rows) {
      this.$router.push({
        path: '/shipmentReport',
        query: {
          reportId: rows.reportId,
          flag: 'check',
          dataFrom: this.dataFrom,
          supplyCode: this.supplyCode
        }
      });
    },
    clickrow(val) {
      this.currentRow = val;
    },
    chosetime() {
      let now = this.time;
      console.log(now, 'nownownow');
      if (now == '' || now == null || now == undefined) {
        this.time = new Date();
        return;
      }
      let year = now.getFullYear();
      let month = now.getMonth(); //得到月份
      this.year = year;
      this.month = month + 1;
      if (this.monthType === h_i18n('f2cf263977bb4fd33b4fed19abfa61ce')) {
        this.searchData.lockFlag = 1;
      } else if (this.monthType === h_i18n('8b2c70fbed996fe6bb9b7e75f5253d47')) {
        let month = new Date().getMonth() + 1;
        if (this.month === month) {
          this.searchData.lockFlag = 0;
        } else {
          this.searchData.lockFlag = 2;
        }
      }
    },
    dealDate(row, column, cellValue, index) {
      // 处理时间格式
      return row[column.property] ? moment(row[column.property]).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    handleCurrentChange(val) {
      if (this.year == '' || this.year == null || this.year == undefined) {
        // alert('请选择查询时间');
        return;
      }
      console.log(val, '页码');
      this.pagenation.pageNo = val;
      this.getReportLVist();
    },
    handleSizeChange(val) {
      console.log(val, '条数');
    },
    // 查询url里面的name和nickname
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return null;
    },
    // 查询表格数据
    getReportLVist() {
      this.loading = true;
      if (this.dataFrom == 'hmqm') {
        this.$http({
          method: 'post',
          url: '/base/sitePpm/listPage',
          headers: { 'content-type': 'application/json' },
          data: {
            type: 'HMQM',
            name: this.$route.query.name,
            nickName: this.$route.query.nickName,
            tags: this.$route.query.tags,
            id: this.$route.query.id,
            year: this.year,
            month: this.month,
            ...this.pagenation,
            ...this.searchData
          }
        }).then((res) => {
          console.log(res, '查询到的数据');
          this.loading = false;
          if (res.status == 200) {
            if (res.data.data.records) {
              this.tableData = res.data.data.records;
              this.total = res.data.data.total;
              // 这里是固定的表头，如果没有可不写
              const anotherTableHead = [
                { label: h_i18n('43fe39f608ab4c13e950addea8c9025c'), property: 'plDouble', width: '80px' },
                { label: h_i18n('fd5a9dd14de11ddc59ac8bf5afa32f38'), property: 'rejectsReplenishmentTrip', width: '110px' },
                { label: h_i18n('c2c40bdc6bd1814145f8f19255820f37'), property: 'monthQuantity', width: '90px' },
                { label: h_i18n('4f79fbe60da796e81fbfc91de173d1cc'), property: 'rejectsReplenishmentCount', width: '100px' },
                { label: h_i18n('3bbb9d96a8440b6cb76b553e4e32f64f'), property: 'rejectsReplenishmentPpm', width: '110px' },
                { label: h_i18n('5235606c697b5bff7509e5ebc2105f3b'), property: 'special', width: '100px' },
                { label: h_i18n('629d18cfc39db616e975d30902277d58'), property: 'tripOut', width: '100px' },
                { label: h_i18n('f4995df0f0e9d7a8baae6fa80e38247d'), property: 'twoMonths', width: '100px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('0fa9d1590c4e12905a78e001e7332c5d'), property: 'rectifyStatusName', width: '120px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('6c545c505fa3a4f3ffca3ddc4ae9b051'), property: 'rectifyId', width: '170px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('d055984361167624fa6606d7f4c67bcb'), property: 'rectifyDate', width: '100px' },
                { label: h_i18n('1327f89a362dbe6b435c62cd789f3f3f'), property: 'threeMonths', width: '100px' },
                { label: h_i18n('b68f779e08a9306e5d7e4bc33ed26058'), property: 'stopStatusName', width: '100px' },
                { label: h_i18n('5a6bde275a52b16fafea34e62cb728a2'), property: 'stopId', width: '170px' },
                { label: h_i18n('05d6547b0261f659aabe09d0d60344b3'), property: 'stopDate', width: '100px' },
                { label: h_i18n('464e4f7bff04b7dbd185fde81e0214f1'), property: 'stopRemark', width: '100px' },
                { label: h_i18n('352547b50930fa984d4548fb943713a6'), property: 'twelfthMonths', width: '100px' },
                //{ label: '产线SQE', property: 'sqeMgr', width: '80px' },
                //{ label: 'IQC', property: 'iqcMgr', width: '80px' }
              ];
              for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].yearmonth = this.tableData[i].year + h_i18n('465260fe80b0c3338d06194bb7a94446') + this.tableData[i].month + h_i18n('e42b99d59954ce6437e66f416850425a');
              }
              // 合并2部分的表头
              this.tableHead = [...anotherTableHead]; // 表头信息
            } else {
              this.tableData = '';
              this.total = res.data.data.total;
              // 这里是固定的表头，如果没有可不写
              const anotherTableHead = [
                { label: h_i18n('43fe39f608ab4c13e950addea8c9025c'), property: 'plDouble', width: '80px' },
                { label: h_i18n('fd5a9dd14de11ddc59ac8bf5afa32f38'), property: 'rejectsReplenishmentTrip', width: '110px' },
                { label: h_i18n('c2c40bdc6bd1814145f8f19255820f37'), property: 'monthQuantity', width: '90px' },
                { label: h_i18n('4f79fbe60da796e81fbfc91de173d1cc'), property: 'rejectsReplenishmentCount', width: '100px' },
                { label: h_i18n('3bbb9d96a8440b6cb76b553e4e32f64f'), property: 'rejectsReplenishmentPpm', width: '110px' },
                { label: h_i18n('5235606c697b5bff7509e5ebc2105f3b'), property: 'special', width: '100px' },
                { label: h_i18n('629d18cfc39db616e975d30902277d58'), property: 'tripOut', width: '100px' },
                { label: h_i18n('f4995df0f0e9d7a8baae6fa80e38247d'), property: 'twoMonths', width: '100px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('0fa9d1590c4e12905a78e001e7332c5d'), property: 'rectifyStatusName', width: '120px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('6c545c505fa3a4f3ffca3ddc4ae9b051'), property: 'rectifyId', width: '140px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('d055984361167624fa6606d7f4c67bcb'), property: 'rectifyDate', width: '100px' },
                { label: h_i18n('1327f89a362dbe6b435c62cd789f3f3f'), property: 'threeMonths', width: '100px' },
                { label: h_i18n('b68f779e08a9306e5d7e4bc33ed26058'), property: 'stopStatusName', width: '100px' },
                { label: h_i18n('5a6bde275a52b16fafea34e62cb728a2'), property: 'stopId', width: '170px' },
                { label: h_i18n('05d6547b0261f659aabe09d0d60344b3'), property: 'stopDate', width: '100px' },
                { label: h_i18n('464e4f7bff04b7dbd185fde81e0214f1'), property: 'stopRemark', width: '100px' },
                { label: h_i18n('352547b50930fa984d4548fb943713a6'), property: 'twelfthMonths', width: '100px' },
                //{ label: '产线SQE', property: 'sqeMgr', width: '80px' },
                //{ label: 'IQC', property: 'iqcMgr', width: '80px' }
              ];
              for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].yearmonth = this.tableData[i].year + h_i18n('465260fe80b0c3338d06194bb7a94446') + this.tableData[i].month + h_i18n('e42b99d59954ce6437e66f416850425a');
              }
              // 合并2部分的表头
              this.tableHead = [...anotherTableHead]; // 表头信息
            }
          }
        });
      } else {
        this.$http({
          method: 'post',
          url: '/base/sitePpm/listPage',
          data: {
            type: 'SQM',
            tags: this.$route.query.tags,
            year: this.year,
            month: this.month,
            ...this.pagenation,
            ...this.searchData
          }
        }).then((res) => {
          console.log(res, '查询到的数据');
          this.loading = false;
          if (res.status == 200) {
            if (res.data.data.records) {
              this.tableData = res.data.data.records;
              this.total = res.data.data.total;
              // 这里是固定的表头，如果没有可不写
              const anotherTableHead = [
                { label: h_i18n('43fe39f608ab4c13e950addea8c9025c'), property: 'plDouble', width: '80px' },
                { label: h_i18n('fd5a9dd14de11ddc59ac8bf5afa32f38'), property: 'rejectsReplenishmentTrip', width: '110px' },
                { label: h_i18n('c2c40bdc6bd1814145f8f19255820f37'), property: 'monthQuantity', width: '90px' },
                { label: h_i18n('4f79fbe60da796e81fbfc91de173d1cc'), property: 'rejectsReplenishmentCount', width: '100px' },
                { label: h_i18n('3bbb9d96a8440b6cb76b553e4e32f64f'), property: 'rejectsReplenishmentPpm', width: '110px' },
                { label: h_i18n('5235606c697b5bff7509e5ebc2105f3b'), property: 'special', width: '100px' },
                { label: h_i18n('629d18cfc39db616e975d30902277d58'), property: 'tripOut', width: '100px' },
                { label: h_i18n('f4995df0f0e9d7a8baae6fa80e38247d'), property: 'twoMonths', width: '100px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('0fa9d1590c4e12905a78e001e7332c5d'), property: 'rectifyStatusName', width: '120px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('6c545c505fa3a4f3ffca3ddc4ae9b051'), property: 'rectifyId', width: '140px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('d055984361167624fa6606d7f4c67bcb'), property: 'rectifyDate', width: '100px' },
                { label: h_i18n('1327f89a362dbe6b435c62cd789f3f3f'), property: 'threeMonths', width: '100px' },
                { label: h_i18n('b68f779e08a9306e5d7e4bc33ed26058'), property: 'stopStatusName', width: '100px' },
                { label: h_i18n('5a6bde275a52b16fafea34e62cb728a2'), property: 'stopId', width: '170px' },
                { label: h_i18n('05d6547b0261f659aabe09d0d60344b3'), property: 'stopDate', width: '100px' },
                { label: h_i18n('464e4f7bff04b7dbd185fde81e0214f1'), property: 'stopRemark', width: '100px' },
                { label: h_i18n('352547b50930fa984d4548fb943713a6'), property: 'twelfthMonths', width: '100px' },
                //{ label: '产线SQE', property: 'sqeMgr', width: '80px' },
                //{ label: 'IQC', property: 'iqcMgr', width: '80px' }
              ];
              for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].yearmonth = this.tableData[i].year + h_i18n('465260fe80b0c3338d06194bb7a94446') + this.tableData[i].month + h_i18n('e42b99d59954ce6437e66f416850425a');
              }
              // 合并2部分的表头
              this.tableHead = [...anotherTableHead]; // 表头信息
            } else {
              this.tableData = '';
              this.total = res.data.data.total;
              // 这里是固定的表头，如果没有可不写
              const anotherTableHead = [
                { label: h_i18n('43fe39f608ab4c13e950addea8c9025c'), property: 'plDouble', width: '80px' },
                { label: h_i18n('fd5a9dd14de11ddc59ac8bf5afa32f38'), property: 'rejectsReplenishmentTrip', width: '110px' },
                { label: h_i18n('c2c40bdc6bd1814145f8f19255820f37'), property: 'monthQuantity', width: '90px' },
                { label: h_i18n('4f79fbe60da796e81fbfc91de173d1cc'), property: 'rejectsReplenishmentCount', width: '100px' },
                { label: h_i18n('3bbb9d96a8440b6cb76b553e4e32f64f'), property: 'rejectsReplenishmentPpm', width: '110px' },
                { label: h_i18n('5235606c697b5bff7509e5ebc2105f3b'), property: 'special', width: '100px' },
                { label: h_i18n('629d18cfc39db616e975d30902277d58'), property: 'tripOut', width: '100px' },
                { label: h_i18n('f4995df0f0e9d7a8baae6fa80e38247d'), property: 'twoMonths', width: '100px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('0fa9d1590c4e12905a78e001e7332c5d'), property: 'rectifyStatusName', width: '120px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('6c545c505fa3a4f3ffca3ddc4ae9b051'), property: 'rectifyId', width: '140px' }, // 2022年10月18日 质量抢单升级需求
                { label: h_i18n('d055984361167624fa6606d7f4c67bcb'), property: 'rectifyDate', width: '100px' },
                { label: h_i18n('1327f89a362dbe6b435c62cd789f3f3f'), property: 'threeMonths', width: '100px' },
                { label: h_i18n('b68f779e08a9306e5d7e4bc33ed26058'), property: 'stopStatusName', width: '100px' },
                { label: h_i18n('5a6bde275a52b16fafea34e62cb728a2'), property: 'stopId', width: '170px' },
                { label: h_i18n('05d6547b0261f659aabe09d0d60344b3'), property: 'stopDate', width: '100px' },
                { label: h_i18n('464e4f7bff04b7dbd185fde81e0214f1'), property: 'stopRemark', width: '100px' },
                { label: h_i18n('352547b50930fa984d4548fb943713a6'), property: 'twelfthMonths', width: '100px' },
                //{ label: '产线SQE', property: 'sqeMgr', width: '80px' },
                //{ label: 'IQC', property: 'iqcMgr', width: '80px' }
              ];
              for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].yearmonth = this.tableData[i].year + h_i18n('465260fe80b0c3338d06194bb7a94446') + this.tableData[i].month + h_i18n('e42b99d59954ce6437e66f416850425a');
              }
              // 合并2部分的表头
              this.tableHead = [...anotherTableHead]; // 表头信息
            }
          }
        });
      }
    },
    EXport() {
      //导出方法
      if (this.total > 200000) {
        proxy.warning({ message: h_i18n('c54045d692bedb6365e073ce45b4e57e'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6'), confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'), callback: (action) => {} });
        return;
      }
      if (this.total < 1) {
        proxy.warning({ message: h_i18n('f59ec2b6c282f2c37663f524c2a318c3'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6'), confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'), callback: (action) => {} });
        return;
      }
      if (this.dataFrom == 'hmqm') {
        this.$http({
          method: 'post',
          url: '/vmiService/sitePpm/exportHmqm',
          data: {
            type: 'HMQM',
            name: this.$route.query.name,
            nickName: this.$route.query.nickName,
            tags: this.$route.query.tags,
            id: this.$route.query.id,
            year: this.year,
            month: this.month,
            ...this.searchData
          }
        })
          .then((res) => {
            if (res.status == 200) {
              this.info({
                message: res.data.msg || h_i18n('ad41f526b0670a747ed5827e062c1ad9'),
                title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
                confirmButtonText: h_i18n('937902e1941d0feb2cd108ed4aa79d21'),
                cancelButtonText: h_i18n('b15d91274e9fc68608c609999e0413fa'),
                callback: (action) => {
                  if (action == 'confirm') {
                    this.toDC();
                  } else {
                  }
                  this.closeLoading();
                }
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$http({
          method: 'post',
          url: '/base/sitePpm/exportSqm',
          data: {
            type: 'SQM',
            tags: this.$route.query.tags,
            year: this.year,
            month: this.month,
            ...this.searchData
          }
        })
          .then((res) => {
            if (res.status == 200) {
              this.info({
                message: res.data.msg || h_i18n('ad41f526b0670a747ed5827e062c1ad9'),
                title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
                confirmButtonText: h_i18n('937902e1941d0feb2cd108ed4aa79d21'),
                cancelButtonText: h_i18n('b15d91274e9fc68608c609999e0413fa'),
                callback: (action) => {
                  if (action == 'confirm') {
                    this.toDC();
                  } else {
                  }
                  this.closeLoading();
                }
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  },
  mounted() {
    if (process.env.NODE_ENV == 'test') {
      this.NODE_ENV = 'test';
    } else if (process.env.NODE_ENV == 'production') {
      this.NODE_ENV = 'production';
    }
    console.log(this.NODE_ENV);
    if (this.$route.query.roleCode) {
      this.roleCode = this.$route.query.roleCode;
    }
    if (this.$route.query.supplyCode) {
      this.supplyCode = this.$route.query.supplyCode;
    }
    if (this.$route.query.dataFrom) {
      this.dataFrom = this.$route.query.dataFrom;
    }
    if (this.$route.query.name || this.$route.query.nickName) {
      window.getItemName = this.$route.query.name;
      window.getItemNickName = this.$route.query.nickName;
    }
    let now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth(); //得到月份
    this.year = year;
    this.month = month + 1;
    if (this.dataFrom == 'sqm') {
      this.searchData.supplyCode = this.$route.query.supplyCode;
      this.getReportLVist();
    }
    if (this.dataFrom == 'hmqm') {
      // this.getNewproductList();
    }
  }
};
if (window.location.search) {
  let search = window.location.search;
  window.location.replace('/#/scenePPM' + search);
}
</script>

<style lang="scss">
.mlHidden {
  display: none !important;
}

.reportTemplateList {
  .search {
    .searchLable {
      width: 30%;
    }

    .searchContent {
      width: 70%;
    }
  }

  .disableBut {
    color: gray !important;
    cursor: default !important;
  }

  .lable-left {
    margin-top: 0px;
    padding-right: 20px;
    border-bottom: 1px solid #e5e6e7;

    span {
      font-size: 1.5em;
      line-height: 33px;
      color: #333;
    }

    i {
      color: #387cd7;
      padding-right: 10px;
    }
  }

  .spanLikeA {
    color: #3a8ee6;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>